import SettingsCard from '../../../../components/ui/SettingsCard';
import Button from '../../../../components/ui/Button';

/**
 * Admin-only card showing pending technician account deletion requests.
 * All mutations stay in the parent (Team.jsx); this component renders
 * and forwards events via props.
 */
export default function DeletionRequestsCard({
  deletionRequests,
  deletionRequestsError,
  updateDeletionRequestMutation,
}) {
  return (
    <SettingsCard
      title="Technician deletion requests"
      className="team-card"
      style={{ marginTop: '1.5rem' }}
    >
      {deletionRequestsError ? (
        <p className="text-muted">Failed to load deletion requests.</p>
      ) : null}
      {deletionRequests.length === 0 ? (
        <p className="text-muted">No deletion requests.</p>
      ) : (
        <div className="team-mobile-cards">
          {deletionRequests.map((req) => (
            <div key={req.id} className="team-mobile-card">
              <div className="team-mobile-card-name">
                {[req.first_name, req.last_name].filter(Boolean).join(' ') || req.email}
              </div>
              <div className="team-mobile-card-email">{req.email}</div>
              <div className="team-mobile-card-status text-muted" style={{ fontSize: '0.875rem' }}>
                Status: {req.status}
              </div>
              {req.reason ? (
                <p style={{ marginTop: '0.5rem', marginBottom: '0.75rem' }}>{req.reason}</p>
              ) : null}
              <div className="team-mobile-card-actions">
                <Button
                  type="button"
                  size="sm"
                  variant="secondary"
                  onClick={() => updateDeletionRequestMutation.mutate({ id: req.id, status: 'addressed' })}
                  disabled={updateDeletionRequestMutation.isLoading || req.status !== 'open'}
                >
                  Mark addressed
                </Button>
                <Button
                  type="button"
                  size="sm"
                  variant="secondary"
                  className="team-btn-delete team-mobile-btn-delete"
                  onClick={() => updateDeletionRequestMutation.mutate({ id: req.id, status: 'rejected' })}
                  disabled={updateDeletionRequestMutation.isLoading || req.status !== 'open'}
                >
                  Reject
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </SettingsCard>
  );
}
